import { getTagsIntersection } from "./getTagsIntersection";

export const getNotSharedTags = (tagsArrays: string[][]) => {
  const sharedTags = getTagsIntersection(tagsArrays);
  const flatTagsArray = tagsArrays.flatMap((tags) => tags);

  return Array.from(new Set(flatTagsArray.filter((tag) => !sharedTags.includes(tag))));
};
